import { render, staticRenderFns } from "./thirdaprty_set.vue?vue&type=template&id=5cca0587&scoped=true"
import script from "./thirdaprty_set.vue?vue&type=script&lang=js"
export * from "./thirdaprty_set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca0587",
  null
  
)

export default component.exports